(()=>{
  if(window.__dhsCollectionCartDrawer)return;
  window.__dhsCollectionCartDrawer=true;
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('.dhs-collection-card__form');
    if(!form)return;
    const drawer=document.querySelector('cart-drawer');
    if(!drawer||typeof drawer.renderContents!=='function')return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    if(button?.disabled)return;
    const original=button?.textContent;
    if(button){button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Adding...'}
    form.querySelector('.dhs-collection-card__error')?.remove();
    try{
      const data=new FormData(form);
      data.append('sections',drawer.getSectionsToRender().map(section=>section.id));
      data.append('sections_url',location.pathname);
      const response=await fetch((window.routes?.cart_add_url||'/cart/add')+'.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
      const state=await response.json();
      if(!response.ok||state.status)throw new Error(state.description||state.message||'Unable to add this item.');
      drawer.renderContents(state);
    }catch(error){
      const message=document.createElement('p');
      message.className='dhs-collection-card__error';
      message.setAttribute('role','alert');
      message.textContent=error.message||'Unable to add this item.';
      form.appendChild(message);
    }finally{
      if(button){button.disabled=false;button.removeAttribute('aria-busy');button.textContent=original}
    }
  });
})();